module.exports = __webpack_public_path__ + "img/SketchPngd690b3c406458df4e1b3a470f6d3aa2dc741c5078360fac1b94f552ee6454762.6aa5b930.png";